module.exports = __webpack_public_path__ + "static/media/IMG_4200.f86479b8.JPG";